import classNames from 'classnames'
import {memo, useCallback} from 'react'
import * as React from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../hooks/react-redux'
import IconButton from '../../../../common/IconButton/IconButton'
import {parameterGroups} from '../../Parameters.slice'
import type {GroupItem} from '../../Parameters.types'
import {getSectionTitle} from '../../utils/getSectionTitle'

import styles from './ParametersGroupHeader.css'

interface Props {
  className?: string
  item: GroupItem
}
function ParametersGroupHeaderComponent(props: Props) {
  const {group, category, matches} = props.item

  const expanded = useAppSelector(state => state.parameterGroups.expanded[category][group])
  const dispatch = useAppDispatch()

  const onClick = useCallback(() => {
    dispatch(parameterGroups.actions.toggleGroup({category, group}))
  }, [dispatch, category, group])

  return (
    <div role="rowheader" aria-expanded={expanded}>
      <IconButton
        className={classNames(styles.groupTitle, props.className)}
        title={expanded ? 'Collapse section' : 'Expand section'}
        icon={expanded ? 'chevron-down' : 'chevron-right'}
        onClick={onClick}
      >
        <div className={styles.text}>{getSectionTitle(group)}</div>
        {matches != null && <span className={styles.matches}>{`${matches} matches`}</span>}
      </IconButton>
    </div>
  )
}

export const ParametersGroupHeader = memo<Props>(ParametersGroupHeaderComponent)
